import { useEffect, useState } from "react";
import { api } from "../lib/api";

export type Me = { email: string; role: "user" | "reviewer" | "admin"; licenseActive: boolean; hasPassword: boolean } | null;

export function useMe() {
  const [me, setMe] = useState<Me>(null);
  const [loading, setLoading] = useState(true);
  const reload = () =>
    api<{ user: Me }>("/api/me")
      .then((r) => setMe(r.user))
      .catch(() => setMe(null))
      .finally(() => setLoading(false));
  useEffect(() => {
    reload();
  }, []);
  return { me, loading, reload };
}
